export const OPEN_CONFIRM_MODAL = 'confirmModal/OPEN_CONFIRM_MODAL';
export const CLOSE_CONFIRM_MODAL = 'confirmModal/CLOSE_CONFIRM_MODAL';
